import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {assetLocationsTableReady,rowsPerPageState,searchTextState,paginationState,assetLocationIdForAction,previousFilterStatus,previousFilterGroupId} from '../redux/assetLocations'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/assetLocationsTable.css'


import {EntityStatus} from '../../../common/DropDowns/index'


import * as Helpers from '../../../common/helpers'


function filterUnwantedData(assetLocationsData) {
    let array = []
    if (assetLocationsData && assetLocationsData.data && assetLocationsData.data.list) {
        array = assetLocationsData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.status = lineData.status ? lineData.status : ""

             if(lineData.location_type==="Kitchen"){
                 newLineData.location = lineData.kitchen_work_location && lineData.kitchen_work_location.name ? lineData.kitchen_work_location.name : "NA"
            }else{
                 newLineData.location = lineData.office_work_location && lineData.office_work_location.name ? lineData.office_work_location.name : "NA"
             }


             newLineData.asset_id = ""
                newLineData.asset_name =  ""
                newLineData.asset_brand_name = ""
                newLineData.asset_serial_number = ""
                newLineData.asset_tag_name =  ""

                newLineData.asset_city =  ""
                newLineData.asset_type =  ""
            
            if(lineData.asset && lineData.asset!==undefined && lineData.asset!==""){
                newLineData.asset_id = lineData.asset.id ? lineData.asset.id : ""
                newLineData.asset_name = lineData.asset.name ? lineData.asset.name : "NA"
                newLineData.asset_brand_name = lineData.asset.brand_name ? lineData.asset.brand_name : "NA"
                newLineData.asset_serial_number = lineData.asset.serial_number ? lineData.asset.serial_number : "NA"
                newLineData.asset_tag_name = lineData.asset.tag_name ? lineData.asset.tag_name : "NA"


                newLineData.asset_city = lineData.asset.city && lineData.asset.city.name ? lineData.asset.city.name : "NA"
                newLineData.asset_type = lineData.asset.asset_type && lineData.asset.asset_type.name ? lineData.asset.asset_type.name : "NA"
            }

            newLineData.incharge = lineData.incharge && lineData.incharge.name ? lineData.incharge.name+" - "+lineData.incharge.code : "NA"


            newArray[i] = newLineData
        }
    }
    return newArray
}


class AssetLocationsTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            assetLocationsData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            filter_group_id:"",
            filter_status:"ACTIVE",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(assetLocationsTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.ASSET_LOCATIONS_TABLE))
        this.props.dispatch(subHeaderDataUpdate())


        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

            let previousFilterStatus=""
            let previousFilterGroupId=""

         if (this.props.assetLocations && this.props.assetLocations.previousFilterStatus && this.props.assetLocations.previousFilterStatus!==undefined) {
            previousFilterStatus=this.props.assetLocations.previousFilterStatus
         }         

         if (this.props.assetLocations && this.props.assetLocations.previousFilterGroupId && this.props.assetLocations.previousFilterGroupId!==undefined) {
            previousFilterGroupId=this.props.assetLocations.previousFilterGroupId
         }

         if(previousFilterStatus===undefined || previousFilterStatus===null || previousFilterStatus===""){
            previousFilterStatus="ACTIVE"
         }
         
         this.setState({
              filter_status:previousFilterStatus,
              filter_group_id:previousFilterGroupId
         },() => {
            this.getAssetLocationsData();
        });

        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getAssetLocationsData = () => {
        apiService.getAssetLocationsData()
            .then(assetLocationsData => {
                if (assetLocationsData && this.isComponentMounted) {
                    this.validateBuildNumber(assetLocationsData)
                    if (assetLocationsData.status === "SUCCESS") {
                        let array = filterUnwantedData(assetLocationsData), pageNo = 1
                        if (this.props.assetLocations && this.props.assetLocations.previousPaginationValue) {
                            pageNo = this.props.assetLocations.previousPaginationValue
                        }
                        this.setState({
                            assetLocationsData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: assetLocationsData.reason ? assetLocationsData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(assetLocationsTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(assetLocationsTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

     entityStatusChange= (data) => {
    
      if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterStatus(""))
             this.setState({
                filter_status :"",            
            })
        }else{
            this.props.dispatch(previousFilterStatus(data.value))
            this.setState({
                filter_status :data.value,            
            })
        }
    }

    assetLocationsGroupChange= (data) => {
    
      if(data.value==="" || data.value===undefined){
             this.props.dispatch(previousFilterGroupId(""))
             this.setState({
                filter_group_id :"",            
            })
        }else{
            this.props.dispatch(previousFilterGroupId(data.value))
            this.setState({
                filter_group_id :data.value,            
            })
        }
    }


    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.assetLocations && this.props.assetLocations.previousRowsPerPageValue) {
            value = this.props.assetLocations.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   {(() =>{

                    if(Helpers.checkPrivileges("/dashboard/assetLocations/addEdit",this.props.user)){
                    return(
                        <div className="col-md-1 col-sm-12 col-xs-12 div-margins">
                            <button className="btn btn-primary button-custom"
                                    style={{ marginLeft: "5px" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.props.dispatch(assetLocationIdForAction())
                                        this.props.history.push("/dashboard/assetLocations/addEdit")
                                    }}>
                                    Add
                                </button>
                         </div>

                        )
                      }
                   })()}
                   
                   
                    <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                    <div className="form-group">
                        <EntityStatus type="ASSETS" entityStatusChange={this.entityStatusChange} selectedValue={this.state.filter_status} /> 
                    </div>
                    </div>

                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredAssetLocationList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.assetLocationsData.length>=(this.props.assetLocations.previousPaginationValue*this.props.assetLocations.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.assetLocations.previousPaginationValue*this.props.assetLocations.previousRowsPerPageValue)-this.props.assetLocations.previousRowsPerPageValue+1} to {this.props.assetLocations.previousPaginationValue*this.props.assetLocations.previousRowsPerPageValue} of {this.state.assetLocationsData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.assetLocations.previousPaginationValue*this.props.assetLocations.previousRowsPerPageValue)-this.props.assetLocations.previousRowsPerPageValue+1} to {this.state.assetLocationsData.length} of {this.state.assetLocationsData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredAssetLocationList = () => {
       
        this.props.dispatch(assetLocationsTableReady(false))
        this.resetSearchAndPagination()
        this.getAssetLocationsData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getAssetLocationsData()
        this.props.dispatch(assetLocationsTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }


    resetFilterValues = () => {
        this.props.dispatch(assetLocationsTableReady(false))
        this.setState({
            filter_status:"",
            filter_group_id:"",
        },() => {
             this.resetPagination()
        
            this.props.dispatch(searchTextState(""))
            this.searchBox.wrappedInstance.refs.searchInput.value = ""
            this.searchBox.props.search("")

            this.props.dispatch(previousFilterStatus(""))
            this.props.dispatch(previousFilterGroupId(""))

            this.getAssetLocationsData()
        });

        
    }

    actionButtonsCreator = (cell, row) => {
        let editButton =""


        if(Helpers.checkPrivileges("/dashboard/assetLocations/addEdit",this.props.user)){
        
            editButton=<button
                className="action-button"
                style={{ width: "70px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editAsset(row)
                }}>
                Edit
            </button>
        }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editButton}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.assetLocations && this.props.assetLocations.previousPaginationValue
            && this.props.assetLocations.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editAsset = (row) => {
        if (row && row.id) {
            this.props.dispatch(assetLocationIdForAction(row.id))
            this.props.history.push("/dashboard/assetLocations/addEdit")
        } else {
            this.dialog.show({
                title: "Asset Identification number not found",
                body: 'Asset id is not available, So not able edit assetLocations',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.assetLocations && this.props.assetLocations.previousRowsPerPageValue) {
            sizeperPage = this.props.assetLocations.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="assetLocations-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.assetLocationsData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}>
                      {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}
                        
                    <TableHeaderColumn
                        dataField="asset_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="asset_brand_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Brand
                    </TableHeaderColumn>
                        
                    <TableHeaderColumn
                        dataField="asset_serial_number"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       SL/no
                    </TableHeaderColumn>
                        
                    <TableHeaderColumn
                        dataField="asset_tag_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Tag
                    </TableHeaderColumn>
                        
                    <TableHeaderColumn
                        dataField="asset_type"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Type
                    </TableHeaderColumn>
                    
                        
                    <TableHeaderColumn
                        dataField="asset_city"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       City
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="location"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Location
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="incharge"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Incharge
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="status"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Status
                    </TableHeaderColumn>
                    

                    
                    
                     <TableHeaderColumn
                        //width="110"
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        assetLocations: state.assetLocations
    }
}

export default connect(mapStateToProps)(withRouter(AssetLocationsTable))


// WEBPACK FOOTER //
// ./src/modules/Asset Locations/Components/AssetLocationsTable.js